import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const forbiddenLocationCharacters = [':', '<', '>', '\\'];

export function hasForbiddenLocationCharactersValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value as string | null | undefined;

        if (!value || value.trim().length === 0) {
            return null;
        }

        if (forbiddenLocationCharacters.some(char => value.includes(char))) {
            return { forbiddenLocationCharacters: true }
        }

        return null;
    };
}